"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var SpecifiedItemsInfoModal = /** @class */ (function (_super) {
    __extends(SpecifiedItemsInfoModal, _super);
    function SpecifiedItemsInfoModal(props) {
        return _super.call(this, props) || this;
    }
    SpecifiedItemsInfoModal.prototype.render = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.props.closeModal });
        return (React.createElement(reactstrap_1.Modal, { id: "specifiedItemsInfo", className: "my-2 info-modal", isOpen: this.props.isOpen, toggle: this.props.closeModal },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.props.closeModal, close: closeBtn },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("img", { className: "d-block mr-3 mb-1 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "info selected icon" }),
                    React.createElement("div", { className: "text-blue-2 font-weight-medium" }, "Specified items"))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0" },
                React.createElement("p", null, "We need to know about items worth more than \u00A32,000 that you take away from the home and valuables in your home."),
                React.createElement("p", null, "We don't need to know about TVs and items of furniture as these will be included as part of your contents cover."),
                React.createElement("p", null, "Examples of items you'd take away from the home could be items you would normally wear or carry like watches, jewellery or laptops belonging to you or your family or which you or your family are legally responsible for."),
                React.createElement("p", null, "Our definition of valuables in the home is: jewellery, watches, furs, items made of gold, silver and other precious metals, pictures and other works of art, stamp, coin and medal collections.")),
            React.createElement(reactstrap_1.ModalFooter, { className: "d-flex" },
                React.createElement("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", onClick: this.props.closeModal }, "Ok, I understand"))));
    };
    return SpecifiedItemsInfoModal;
}(React.Component));
exports.default = SpecifiedItemsInfoModal;
//# sourceMappingURL=SpecifiedItemsInfoModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/valuableItemWidget/SpecifiedItemsInfoModal.js
// module id = 3691
// module chunks = 0